import { billOfMaterialsIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const deleteBillOfMaterials = {
  name: "deleteBillOfMaterials" as const,
  input: z.object({ billOfMaterialsId: billOfMaterialsIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
